<!--
  只展示标题和返回键的头部
-->
<template>
  <div class="header-box">
    <div class="title-header" ref="title_header">
      <div class="back-icon-box" v-show="!hideBack">
        <i class="iconfont icon-fanhui1 go-back-icon" @click="goBack"></i>
      </div>
      <div class="settle-title">{{ title }}</div>
      <div class="top-nav-box">
        <slot></slot>
        <van-icon v-show="!hideNav" name="ellipsis" size="25" @click="showNavList" v-click-outside="handleClickOutSide" />
      </div>
    </div>
    <div class="nav-list-box" v-show="display.navList" >
      <div class="nav-item" @click="gotoPage(0)">
        <van-icon class="nav-item-icon" name="home-o" size="18" />
        <span class="nav-item-name">首页</span>
      </div>
      <div class="nav-item" @click="gotoPage(1)">
        <van-icon class="nav-item-icon" name="apps-o" size="18" />
        <span class="nav-item-name">分类</span>
      </div>
      <div class="nav-item" @click="gotoPage(2)">
        <van-icon class="nav-item-icon" name="shopping-cart-o" size="18" />
        <span class="nav-item-name">购物车</span>
      </div>
      <div class="nav-item" @click="gotoPage(3)">
        <van-icon class="nav-item-icon" name="friends-o" size="18" />
        <span class="nav-item-name">个人中心</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: '',
      type: String,
    },
    cunstomBack: {
      //是否自定义返回函数
      default: false,
      type: Boolean,
    },
    hideBack: {
      default: false,
      type: Boolean,
    },
    hideNav: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      display: {
        navList: false
      }
    }
  },
  mounted() {
    //组件加载完成
    this.$emit('load-success')
  },
  methods: {
    goBack() {
      if (this.cunstomBack) {
        this.$emit('goback');
      } else {
        this.$router.go(-1);
      }
    },
    //打开导航列表
    showNavList() {
      this.display.navList = !this.display.navList;
    },
    handleClickOutSide(){
      this.display.navList = false;
    },
    //跳转
    gotoPage(type) {
      let name = '';
      switch (type) {
        case 0:
          name = 'home';
          break;
        case 1:
          name = 'classify';
          break;
        case 2:
          name = 'shopCart';
          break;
        case 3:
          name = 'mine';
          break;
      }
      this.$router.push({
        name
      })
    }
  },
};
</script>

<style scoped lang="scss">
  @import 'common/sass/theme.scss';
  .header-box{
    position: relative;
    .title-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: $top-nav-height;
      line-height: $top-nav-height;
      padding: 0 10px;
      border-bottom: 1px solid #ededed;
      background: #fff;
      .back-icon-box {
        display: inline-block;
        .go-back-icon {
          font-size: 20px;
        }
      }
      .settle-title {
      }
      .top-nav-box{
        display: flex;
        width: 25px;
        align-items: center;

      }
    }
    .nav-list-box{
      position: absolute;
      right: 10px;
      width: 120px;
      border-radius: 5px;
      color: #fff;
      background: rgba(0,0,0,.9);
      z-index: 999;
      .nav-item{
        padding: 10px;
        font-size: 14px;
        &:not(:last-child){
          border-bottom: 1px solid #494545;
        }
        .nav-item-icon{
          vertical-align: middle;
        }
        .nav-item-name{
          margin-left: 10px;
          vertical-align: middle;
        }
      }
      &:before{
        position: absolute;
        top: -10px;
        right: 5px;
        content: '';
        display: inline-block;
        border: 5px solid transparent;
        border-bottom: 5px solid rgba(0,0,0,.9);
      }
    }
  }
</style>
